import * as yup from 'yup';

export const blastingSiteSchema = yup.object().shape({
	phone: yup.string().required('Phone is required.'),
	address: yup.string().required('Address is required.'),
	city: yup.string().required('City is required.'),
	state: yup.string().required('State is required.'),
	businessName: yup.string().required('Buisness name is requied.'),
	projectName: yup.string().required('Project name is requied.'),
	contactName: yup.string().required('Emergancy contact name is requied.'),

	zip: yup
		.string()
		.required('Zip Code is required.')
		.matches(/[0-9]{5}/g, 'Invalid Zip Code.'),
});
